/**
 * Created by Tiger on 06/06/2022.
 */
/** @jsx jsx */
import {jsx, css} from '@emotion/react'
import React, {FC, useEffect, useMemo, useState} from "react";
import Auth from "./Auth";
import Login from "./Login";
import Password from "./Password";
import VerificationCode from "./VerificationCode";
import {Redirect, Route, Switch} from "react-router-dom";
import {getQueryVariable} from "../../../common/util";
import {http} from "../../../common/request";
import {AxiosResponse} from "axios";
import MobileCountryCode from "./MobileCountryCode";

export type LoginType = 'Phone' | 'Email'

interface LoginForm {
  account: string;
  password?: string;
  code?: string;
  cid?: string;
  country_code?: string
  t?: string
}

interface AuthFrom {
  redirectUrl: string,
  access_key: string,
  cid: string,
  code: string
  nonce: string
}

export interface ContextProps {
  nonce: string;
  cid: string;
  loginWithPassword: (form: LoginForm) => Promise<AxiosResponse<any, any>> | undefined;
  loginWithCode: (form: LoginForm) => Promise<AxiosResponse<any, any>> | undefined;
  getCode: (account: string, countryCode: string) => Promise<AxiosResponse<any, any>> | undefined;
  updateAuth: (auth: AuthFrom) => void;
  updatePhoneCode: (code: string) => void;
  phoneCode: string,
  loginType: LoginType,
  setLoginType: (type: LoginType) => void
}

export const MobileLoginContext = React.createContext<ContextProps | undefined>(undefined)

const MobileWebLogin: FC<any> = (props) => {
  const [auth, setAuth] = useState<AuthFrom | undefined>(undefined);
  const [phoneCode, setPhoneCode] = useState('86');
  const [loginType, setLoginType] = useState<LoginType>('Email');
  const [cid, setCid] = useState(getQueryVariable('login_challenge'));
  const [nonce, setNonce] = useState(getQueryVariable('nonce'));
  useEffect(() => {
    if (auth?.cid && auth.redirectUrl) {
      const authFrom = document.getElementById('authForm') as HTMLFormElement;
      authFrom.submit()
    }
  }, [auth])
  const store = useMemo<ContextProps>(() => {
    return {
      nonce,
      cid,
      loginWithPassword(form) {
        const {account, password, cid, country_code} = form
        return http('get', '/account/login', {
          account,
          password,
          cid,
          country_code
        })
      },
      loginWithCode(form) {
        const {account, cid, code, country_code, t} = form
        return http('get', '/account/verify', {
          account,
          cid,
          country_code,
          t,
          code
        })
      },
      getCode(account, countryCode) {
        return http('get', '/account/requestVerify', {
          account, countryCode
        })
      },
      updateAuth(auth) {
        console.log('updateAuth：', auth)
        setAuth(auth)
      },
      updatePhoneCode(code) {
        setPhoneCode(code)
        console.log('updatePhoneCode:', code)
      },
      phoneCode,
      loginType,
      setLoginType
    }
  }, [auth, phoneCode, loginType])

  return (
    <div css={css`width: 100%;
      height: 100%`}>
      <MobileLoginContext.Provider value={store}>
        <Switch>
          <Route path={'/login/mobile'} exact component={Login}/>
          <Route path={'/login/mobile/password/:account/:loginType/:countryCode'} exact component={Password}/>
          <Route path={'/login/mobile/verificationCode/:account/:loginType/:countryCode'} exact component={VerificationCode}/>
          <Route path={'/login/mobile/auth'} exact component={Auth}/>
          <Route path={'/login/mobile/selectCountryCode'} render={props => <MobileCountryCode {...props} />}/>
          <Redirect to={'/login/mobile'}/>
        </Switch>
        <form style={{display: 'none'}} action={auth?.redirectUrl} method="POST" id="authForm">
          <input type="hidden" id="access_key" name="access_key" value={auth?.access_key}/>
          <input type="hidden" id="cid" name="cid" value={auth?.cid}/>
          <input type="hidden" id="code" name="code" value={auth?.code}/>
          <input type="hidden" id="nonce" name="nonce" value={auth?.nonce}/>
        </form>
      </MobileLoginContext.Provider>
    </div>
  )
}


export default MobileWebLogin
